'use client';

import React from 'react';
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import {
  faHospital,
  faHospitals,
  faUserDoctorHairMullet,
} from '@fortawesome/pro-solid-svg-icons';

const GlobalEmptyState = () => {
  return (
    <div>
      <div className="px-4 py-1 flex justify-start items-center gap-2">
        <div className="justify-start text-primary text-base font-bold font-['Inter'] leading-6">
          Search for...
        </div>
      </div>
      <div className="self-stretch px-3.5 bg-white rounded-2xl inline-flex flex-col justify-start items-start gap-2 overflow-hidden">
        <div className="flex flex-col justify-start items-start gap-3">
          <div className="px-3 py-2 rounded-lg inline-flex justify-start items-center gap-4">
            <div className="w-6 h-6 flex items-center justify-center">
              <Icon
                icon={faHospital}
                size="lg"
                className="w-6 h-5 text-tertiary"
              />
            </div>
            <div className="justify-start text-primary text-base font-normal font-['Inter'] leading-6">
              Hospitals
            </div>
          </div>
          <div className="px-3 py-2 rounded-lg inline-flex justify-start items-center gap-4">
            <div className="w-6 h-6 flex items-center justify-center">
              <Icon
                icon={faHospitals}
                size="lg"
                className="w-6 h-5 text-tertiary"
              />
            </div>
            <div className="justify-start text-primary text-base font-normal font-['Inter'] leading-6">
              Systems
            </div>
          </div>
          <div className="px-3 py-2 rounded-lg inline-flex justify-start items-center gap-4">
            <div className="w-6 h-6 flex items-center justify-center">
              <Icon
                icon={faUserDoctorHairMullet}
                size="lg"
                className="w-6 h-5 text-tertiary"
              />
            </div>
            <div className="justify-start text-primary text-base font-normal font-['Inter'] leading-6">
              Doctors and Nurses
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GlobalEmptyState;
